import { useEffect } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

const ShortRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const controller = new AbortController();

    const resolveAndRedirect = async () => {
      if (!code) {
        navigate("/login", { replace: true });
        return;
      }

      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}/nocApi/shorten/resolve/${code}`,
          {
            method: "GET",
            credentials: "include",
            signal: controller.signal,
          },
        );

        const data = await res.json();

        if (controller.signal.aborted) return;

        if (data?.success && data?.long_url) {
          window.location.replace(data.long_url);
          return;
        }

        navigate("/login", { replace: true });
      } catch (error) {
        if (!controller.signal.aborted) {
          navigate("/login", { replace: true });
        }
      }
    };

    resolveAndRedirect();

    return () => {
      controller.abort();
    };
  }, [code, navigate]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="body1">Redirecting...</Typography>
    </Box>
  );
};

export default ShortRedirect;
